import { debounce } from 'lodash-es';

export default function init() {
  const containers = document.querySelectorAll('.contents__link-to-start');

  function handleResize(item) {
    const contentEl = document.querySelector('.page__layout .column--content');
    const windowHeight = window.innerHeight || 0;
    const contentHeight = contentEl.clientHeight || 0;

    const isContentHighEnough = contentHeight >= windowHeight * 0.7;

    item.classList.toggle('is--hidden', !isContentHighEnough);
  }

  [...containers].forEach((container) => {
    handleResize(container);

    window.addEventListener(
      'resize',
      debounce(() => { handleResize(container); }, 150),
    );
  });
}
